<template>
	<div class="signle-wrapper">
		<top :pagetitle="$t('密码重置成功')"></top>
		<div class="signle-main">
			<div class="form-panel">
				<div class="form-in">
					<div class="regist-result">
						<div class="result-icon">
							<img src="@/assets/images/success.png" alt="">
						</div>
						<div class="result-grid">
							<h3>{{$t('密码重置成功')}}</h3>
							<p>{{$t('请妥善保管您的账户信息')}}</p>
						</div>
						<div class="result-foot">
							<router-link to="/login" class="layui-btn layui-btn-primary">
								{{$t('重新登录')}}
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>
<script>
	import top from '@/components/top';
	import bottom from '@/components/bottom';
	export default {
		components:{
			bottom,top
		},
		data() {
			return {
				activeName: 'first',
				form: {
					account: '',
					password: '',
					checked: false,
					code: '',
				}
			};
		},
		methods:{
			onSubmit(){
				
			}
		},
		mounted() {}
	}
</script>
<style scoped>
	@import url("../../assets/css/signle.css");
	.form-links{
		justify-content: center;
	}
</style>